import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import image from "../../assets/images/logo/Team/ajit.webp";
import img from "../../assets/images/logo/Team/anuj.webp";
import img1 from "../../assets/images/logo/Team/deepak.webp";
import img2 from "../../assets/images/logo/Team/nitu.webp";
import img5 from "../../assets/images/logo/Team/arun.webp";
import img3 from "../../assets/images/logo/Team/dn.webp";
import img4 from "../../assets/images/logo/Team/sachin.webp";

const MemberContent = [
  {
    img: img1,
    desig: "Founder & Director",
    name: "Deepak Singh Bisht",
    fade: "fade-up",
    dataDelay: "",
  },
  {
    img: image,
    desig: "Full Stack Engineer",
    name: "Ajit Kumar",
    fade: "fade-up",
    dataDelay: "100",
  },
  {
    img: img2,
    desig: "Full Stack Engineer",
    name: "Nitu Rana",
    fade: "fade-up",
    dataDelay: "200",
  },
  {
    img: img3,
    desig: "Project Manager",
    name: "Deepak Nagar",
    fade: "fade-up",
    dataDelay: "300",
  },
  {
    img: img,
    desig: "Full Stack Engineer",
    name: "Anuj Chauhan",
    fade: "fade-up",
    dataDelay: "",
  },
  {
    img: img5,
    desig: "Full Stack Engineer",
    name: "Arun Kumar",
    fade: "fade-up",
    dataDelay: "100",
  },
  {
    img: img4,
    desig: "Full Stack Engineer",
    name: "Sachin Kanojia",
    fade: "fade-up",
    dataDelay: "200",
  },
  // {
  //   img: img2,
  //   desig: "Android Developer",
  //   name: "Punit Sharma",
  //   fade: "fade-up",
  //   dataDelay: "300",
  // },
];
const images = [
  "../../assets/images/logo/ajit.jpg",
  "../../assets/images/logo/anuj.jpg",
  "../../assets/images/logo/deepak.jpg",
  "../../assets/images/logo/yash.jpg",
  "../../assets/images/logo/anuj.jpg",
];

const TeamMemberTwo = () => {
  return (
    <Fragment>
      <div className="row">
        {MemberContent.map((val, i) => (
          <div
            key={i}
            className="col-xl-3 col-lg-4 col-sm-6"
            data-aos={val.fade}
            data-aos-delay={val.dataDelay}
          >
            <div className="team-block-one tran3s mt-50 md-mt-30">
              <div className="img-meta">
                <img src={val.img} alt="" width={200} />
              </div>

              <Link to="" className="team-info">
                {/* <span className="designation-text">{val.img}</span> */}
                <span className="designation-text">{val.desig}</span>
                <span className="name tran3s">{val.name}</span>
              </Link>
            </div>

            {/* /.team-block-one */}
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default TeamMemberTwo;
